
import React from 'react'

interface InfoIconProps {
  className?: string;
  color?: string;
}

const InfoIcon: React.FC<InfoIconProps> = ({ className , color="#1E293B" }) => {
  return (

    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path fillRule="evenodd" clipRule="evenodd" d="M1.66669 8.5C1.66669 6.73188 2.36907 5.03619 3.61931 3.78595C4.86955 2.53571 6.56524 1.83333 8.33335 1.83333C10.1015 1.83333 11.7972 2.53571 13.0474 3.78595C14.2976 5.03619 15 6.73188 15 8.5C15 10.2681 14.2976 11.9638 13.0474 13.214C11.7972 14.4643 10.1015 15.1667 8.33335 15.1667C6.56524 15.1667 4.86955 14.4643 3.61931 13.214C2.36907 11.9638 1.66669 10.2681 1.66669 8.5ZM9.00002 7.83333V11.8333H7.66669V7.83333H9.00002ZM8.33335 13.8333C6.96499 13.7649 5.67528 13.1731 4.73099 12.1804C3.78671 11.1877 3.2601 9.87007 3.2601 8.5C3.2601 7.12992 3.78671 5.81226 4.73099 4.81956C5.67528 3.82687 6.96499 3.2351 8.33335 3.16666C9.70172 3.2351 10.9914 3.82687 11.9357 4.81956C12.88 5.81226 13.4066 7.12992 13.4066 8.5C13.4066 9.87007 12.88 11.1877 11.9357 12.1804C10.9914 13.1731 9.70172 13.7649 8.33335 13.8333ZM9.00002 5.16666V6.5H7.66669V5.16666H9.00002Z" fill={color}/>
    </svg>
    
    
  )
}

export default InfoIcon




